import { Pipe, PipeTransform } from '@angular/core';
import {VizixService} from "../../providers/vizix.service";

/**
 * Generated class for the ValidateRfidPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'validateRfid',
})
export class ValidateRfidPipe implements PipeTransform {
  constructor(private vizixService: VizixService){
  }
  transform(value: string) {
    let regExp = new RegExp(this.vizixService.configurationApp.AppParametersConfiguration.RFIDValidation.value);
    return regExp.test(value) ? value : "";
  }
}



// WEBPACK FOOTER //
// ./src/pipes/validate-tag/validate-rfid.ts